import React from 'react'
import PropTypes from 'prop-types'
import ViewHeader from './ViewHeader'
import ViewContent from './ViewContent'

import './View.scss'

function View({ header, children }) {
    return (
        <div className="ao-view">
            { header && <ViewHeader>{ header }</ViewHeader> }
            <ViewContent>{ children }</ViewContent>
        </div>
    )
}

View.propTypes = {
    header: PropTypes.oneOfType([ PropTypes.func, PropTypes.object ])
}

export default View
